import React from "react";
import { BanquetSeatingIcon } from "~/icons/BanquetSeatingIcon";
import { BlockSeatingIcon } from "~/icons/BlockSeatingIcon";
import { ClassroomSeatingIcon } from "~/icons/ClassroomSeatingIcon";
import { PartyIcon } from "~/icons/PartyIcon";
import { StandingSeatingIcon } from "~/icons/StandingSeatingIcon";
import { TableSeatingIcon } from "~/icons/TableSeatingIcon";
import { TheatreSeatingIcon } from "~/icons/TheatreSeatingIcon";
import { UFormSeatingIcon } from "~/icons/UFormSeatingIcon";
import { XIcon } from "~/icons/XIcon";
import noImageFound from "~/assets/no-image.svg";
import { resolveAssetUrl } from "~/lib/utils";

export type LocationSeatingLayouts = {
  party: number | null;
  row: number | null;
  parliament: number | null;
  block: number | null;
  uform: number | null;
  banquet: number | null;
  table: number | null;
  standing: number | null;
};

type LocationSeatingLayoutKey = keyof LocationSeatingLayouts;

const layoutsConfig: {
  icon: React.ReactNode;
  valueKey: LocationSeatingLayoutKey;
  label: string;
}[] = [
    { icon: <PartyIcon />, valueKey: "party", label: "Party" },
    { icon: <TheatreSeatingIcon />, valueKey: "row", label: "Reihe" },
    {
      icon: <ClassroomSeatingIcon />,
      valueKey: "parliament",
      label: "Parlament",
    },
    { icon: <BlockSeatingIcon />, valueKey: "block", label: "Block" },
    {
      icon: <UFormSeatingIcon />,
      valueKey: "uform",
      label: "U-Form",
    },
    {
      icon: <BanquetSeatingIcon />,
      valueKey: "banquet",
      label: "Bankett",
    },
    { icon: <TableSeatingIcon />, valueKey: "table", label: "Tafel" },
    { icon: <StandingSeatingIcon />, valueKey: "standing", label: "Stehempfang" },
  ];

interface LocationSeatingCardProps {
  seating: LocationSeatingLayouts;
  images?: Array<{
    id: number | null;
    path: string | null;
    mimetype: string | null;
    alt: string | null;
    size: number | null;
    sort: number | null;
    categoryId: number | null;
    categoryName: string | null;
  }>;
  indoorArea?: number | null;
}

export function LocationSeatingCard({
  seating,
  images = [],
  indoorArea,
}: LocationSeatingCardProps) {
  return (
    <div>
      <div className="flex flex-col gap-4 py-6 md:flex-row md:items-center">
        <div className="flex gap-4 shrink-0 md:mr-[100px] md:basis-[260px]">
          {/* Image - decorative only, does not open gallery */}
          <img
            src={
              images[0]?.path
                ? resolveAssetUrl(images[0]!.path!)
                : noImageFound
            }
            alt="Gesamte Location"
            className="h-[107px] w-[115px] shrink-0 rounded-lg object-cover"
          />

          {/* Infos */}
          <div className="flex flex-col">
            <div className="font-semibold">Gesamte Location</div>
            {indoorArea != null && indoorArea > 0 && (
              <div className="text-sm">{indoorArea} m²</div>
            )}
          </div>
        </div>

        <div className="mt-4 flex flex-wrap items-start justify-start gap-4 md:mt-0 md:flex-nowrap">
          {/* Layouts */}
          {Object.entries(seating).map(([key, value]) => {
            const item = layoutsConfig.find((l) => l.valueKey === key);
            if (!item) return null;

            return (
              <div
                key={key}
                className="flex flex-col items-center justify-center"
              >
                <div className="mb-2">{item.label}</div>
                <div className="rounded-md">{item.icon}</div>
                <span className="mt-2">{value ?? <XIcon />}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
